import { styled, css } from 'styled-components';
import { Icon } from '../../components/Icon';
import { pxToRem } from '../../util';
import { StateLayer } from '../../core-components';
export const StyledCard = styled.div.withConfig({
  componentId: "aui__sc-xr929u-0"
})(["all:unset;position:relative;display:flex;align-items:stretch;border-radius:var(--aui-border-radius-100);background:var(--aui-elevated-dynamic-card);box-sizing:border-box;width:", ";height:", ";padding:var(--aui-spacing-200);gap:var(--aui-spacing-200);overflow:hidden;border:", ";flex-direction:", ";justify-content:", ";color:var(--aui-on-surface);text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,0);box-shadow:", ";&::after{border-radius:calc(var(--aui-border-radius-100) - 1px);content:'';position:absolute;height:100%;width:100%;left:0;top:0;z-index:0;pointer-events:none;}", " ", ""], ({
  $width
}) => $width ?? '100%', ({
  $height
}) => $height ?? 'fit-content', getBorder, getFlexDirection, getJustifyContent, getBoxShadow, ({
  $isInteractive
}) => $isInteractive && css(["transition:transform 0.2s ease;cursor:pointer;&:focus-visible,&:has(:focus-visible){outline-offset:4px;outline:5px auto blue;outline:5px auto -webkit-focus-ring-color;}&:focus-visible,&:has(:focus-visible),&:hover,&:active{", "}&:active{box-shadow:unset;", "{opacity:var(--aui-state-layer-press-card);}&::after{box-shadow:", ";}}"], getHoverStyles, StateLayer, getActiveBoxShadow), ({
  $isSelected
}) => $isSelected && css(["border-color:var(--aui-on-surface);:hover,:active{border-color:var(--aui-on-surface);}&::after,&:hover::after{box-shadow:", ";}&:active::after{box-shadow:", ",", ";}"], getSelectedBoxShadow, getSelectedBoxShadow, getActiveBoxShadow));
export const CheckboxContainer = styled.div.withConfig({
  componentId: "aui__sc-xr929u-1"
})(["background-color:var(--aui-inverse-surface);box-shadow:0 0 0.5rem 0 rgba(255,255,255,0.4);opacity:", ";transition:opacity 0.2s ease-in-out;position:absolute;right:-", "rem;top:-", "rem;transform:rotate(45deg);width:", "rem;height:", "rem;z-index:1;"], ({
  $isChecked
}) => $isChecked ? 1 : 0, pxToRem(22), pxToRem(22), pxToRem(45), pxToRem(45));
export const CheckmarkIcon = styled(Icon.Compat).withConfig({
  componentId: "aui__sc-xr929u-2"
})(["position:absolute;bottom:0;left:14px;transform:rotate(-45deg);"]);
function getBorder({
  $variant
}) {
  if ($variant === 'elevated') {
    return 'var(--aui-stroke-card) solid var(--aui-outline-soft)';
  } else {
    return 'var(--aui-stroke-card) solid var(--aui-outline);';
  }
}
function getBoxShadow({
  $variant
}) {
  if ($variant === 'elevated') {
    return '0 0 4px 2px var(--aui-fills-drop-shadow), 0 0 4px 0 var(--aui-fills-drop-shadow)';
  } else {
    return 'none';
  }
}
function getHoverStyles({
  $variant
}) {
  if ($variant === 'elevated') {
    return css(["box-shadow:0 1px 4px 0 var(--aui-fills-drop-shadow),0 0 12px 8px var(--aui-fills-drop-shadow);border:var(--aui-stroke-card) solid var(--aui-outline-soft);transform:scale(1.01);"]);
  } else {
    return css(["box-shadow:none;border:var(--aui-stroke-card) solid var(--aui-on-surface-soft);"]);
  }
}
function getSelectedBoxShadow() {
  return '0 0 0 calc(var(--aui-stroke-selected-card-hover) - var(--aui-stroke-card)) var(--aui-on-surface) inset';
}
function getActiveBoxShadow() {
  return '2px 2px 8px 4px var(--aui-fills-cards-pressed-shadow) inset';
}
function getFlexDirection({
  $imagePosition
}) {
  return {
    top: 'column',
    left: 'row',
    right: 'row-reverse',
    bottom: 'column-reverse'
  }[$imagePosition] || 'column';
}
function getJustifyContent({
  $imagePosition
}) {
  return {
    top: 'flex-start',
    left: 'flex-start',
    right: 'space-between',
    bottom: 'space-between'
  }[$imagePosition] || 'flex-start';
}